// libraries.
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// slices.
import {
  setDefaultState,
  setShowModal,
} from '@domains/documents-review/store/slices/document-review-slice';
import useBusinessTypeWebSocket from '@domains/hermes/hooks/useBusinessTypeWebSocket';
import {
  getHermesDataBody,
  setHermesData,
} from '@domains/hermes/slices/hermesData.slice';
import { useSaveHermesMutation } from '@domains/hermes/services/hermes.endpoints';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';

// constants.
export { LIEN_LIST_DATA, DROPDOWN_OPTIONS } from './constants';

export const defaultValuesMX = {
  complex: '',
  adminPrice: '',
  propertyType: '',
  medianZone: '',
  zipCode: '',
  committeePriceArea: '',
  committeeLandArea: '',
  rooms: '',
  baths: '',
  halfBaths: '',
  floor: '',
  elevator: '',
  hasGarageDoc: null,
  garage: '',
  yearsOld: '',
  parkingWithDoubleKeyOrDeed: null,
};

export const defaultValuesCO = {
  hasAdmin: null,
  adminPrice: '',
  constructionDate: '',
  areaType: '',
  area: '',
  baths: '',
  floor: '',
  hasGarage: null,
  garage: '',
  hasTerrace: null,
  freeArea: '',
  liens: '',
  lienCategory: '',
  lenderBank: '',
};

export const useHandleMutationToast = (
  isError: boolean,
  isSuccess: boolean
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const country = useSelector(getCountry);
  const bodyForHermes = useSelector(getHermesDataBody);

  const [
    saveHermes,
    {
      isLoading: isLoadingHermes,
      isError: isErrorHermes,
      isSuccess: isSuccessHermes,
      data: dataHermes,
    },
  ] = useSaveHermesMutation();

  // Hook que maneja ambos flujos según business_type
  const { businessType, handleWebSocketSend } = useBusinessTypeWebSocket({
    whenSuccessGeoref: () => {
      navigate('/document-audit/tasks');
      toast.success('¡Hermes Data Actualizada! ');
      dispatch(setShowModal(false));
      dispatch(setDefaultState());
    },
  });

  useEffect(() => {
    if (isError) {
      toast.error('Error al aprobar esta tarea', {
        toastId: 'errorApproveTask',
      });
    } else if (isSuccess) {
      toast.success('Tarea aprobada correctamente', {
        toastId: 'successApproveTask',
      });

      // Lógica según business_type:
      if (businessType === 'real_estate') {
        // Para real_estate: enviar directamente al websocket
        handleWebSocketSend();
      } else {
        // Para committee: usar el flujo normal (change_coordinates)
        saveHermes(bodyForHermes).unwrap();
      }
    }
  }, [isError, isSuccess, dispatch, businessType]);

  // Hermes status.
  useEffect(() => {
    if (isLoadingHermes) {
      toast.info('Enviando datos a Hermes...', {
        toastId: 'loadingHermes',
      });
    } else {
      toast.dismiss('loadingHermes');
    }
  }, [isLoadingHermes]);

  useEffect(() => {
    if (isErrorHermes) {
      toast.error('Error al enviar datos a Hermes', {
        toastId: 'errorHermes',
      });
    }
  }, [isErrorHermes]);

  useEffect(() => {
    if (isSuccessHermes) {
      let hermes = dataHermes;

      if (country === 'CO') {
        hermes = {
          ...dataHermes,
          validations: true,
        };
      }
      toast.success('Enviando datos a sellers', {
        toastId: 'successHermes',
      });
      dispatch(setHermesData(hermes));
    }
  }, [isSuccessHermes, dataHermes]);
};
